import React, { Component } from 'react';
import { injectIntl, intlShape } from 'react-intl';
import ReactMarkdown from 'react-markdown'
import { NavLink } from 'react-router-dom';
import { connect } from 'react-redux';
import { fetchMenu } from '../redux/actions';
import slug from 'slug';
import Helmet from 'react-helmet';
import './MenuPage.css';

import FullbleedHero from '../components/ContentBlocks/FullbleedHero';
import RenderProduct from '../components/RenderProduct';
import RenderCategory from '../components/RenderCategory';

class MenuPage extends Component {

  componentDidMount() {
    const locale = this.props.intl.locale;

    if (!this.props.menus.length) {
      this.props.fetchMenu(this.props.date, locale);
    }
  }

  componentDidUpdate() {
      const restaurantSlug = this.props.match.params.restaurant;
      const menuSlug = this.props.match.params.slug;
      const menus = this.props.menus;
    
      const menu = menus.find(menu => {
        if(slug(menu.fields.title.toLowerCase()) !== menuSlug) {
          return false;
        }
    
        if(restaurantSlug) {
            const restaurants = menu.fields.restaurant || [];
            return Array.isArray(restaurants) && restaurants.some(restaurant => slug(restaurant.toLowerCase()) === restaurantSlug);
        }
    
        return true;
      });
    
      if(menus.length && !menu) {
        this.props.history.replace('/menu');
      }
}

  render() {
    const restaurantSlug = this.props.match.params.restaurant;
    const menuSlug = this.props.match.params.slug;
    const menuSubSlug = this.props.match.params.subslug;
    const {menus, categories, products} = {...this.props};

    return (
      <div className="menu">
        {menus && menus.map((menu) => {
            if(menuSlug !== slug(menu.fields.title.toLowerCase())) {
              return null;
            }

            if(restaurantSlug) {
                const restaurants = menu.fields.restaurant || [];

                if(!Array.isArray(restaurants) || !restaurants.some(restaurant => slug(restaurant.toLowerCase()) === restaurantSlug)) {
                  return null;
                }
            }

          return (
            <div key={menu.fields.title}>
              <Helmet title={menu.fields.title} />
              { menu.fields.specialDiets &&
                <div className="special-diets">
                  <FullbleedHero key={menu.sys.id} fields={{
                    heading: menu.fields.title,
                    lead: menu.fields.description,
                  }} />
                </div>
              }
              { !menu.fields.specialDiets &&
              <div className={'category cols-'+menu.fields.columns} id={slug(menu.fields.title.toLowerCase())}>
                  <div className="container">
                    {(menu.fields.parentMenu && menu.fields.children) && 
                      <nav className="submenu-nav">
                      {menu.fields.children.map((child) => {
                        let menu = menus.find((p) => {
                          return p.sys.id === child.sys.id
                        })

                        if(menu) {
                          return(
                            <NavLink to={(restaurantSlug ? '/menu/'+restaurantSlug : '/menu')+'/'+menuSlug+'/'+slug(menu.fields.title.toLowerCase())} key={menu.sys.id} activeClassName="active">{menu.fields.title}</NavLink>
                          )
                        }

                        return null;
                      })}
                      </nav>
                    } 
                    <div className="products-wrapper">
                      {!menuSubSlug && <h1>{menu.fields.longTitle ? menu.fields.longTitle : menu.fields.title}</h1>}
                      {!menuSubSlug && <ReactMarkdown source={menu.fields.description} softBreak="br" />}
                      
                      <div className="products-categories">
                        {menu.fields.children && menu.fields.children.map((child) => {
                          let product = products.find((p) => {
                            return p.sys.id === child.sys.id
                          })
                          let category = categories.find((p) => {
                            return p.sys.id === child.sys.id
                          })

                          if(product) {
                            return(
                              <RenderProduct product={product} key={product.fields.title} {...this.props} />
                            )
                          }

                          if(category) {
                            return(
                              <RenderCategory category={category} key={category.fields.title} {...this.props} />
                            )
                          }

                          return null;
                        })}
                      </div>
                      {menu.fields.children && menu.fields.children.map((child) => {
                        let menu = menus.find((p) => {
                          return p.sys.id === child.sys.id
                        })

                        if(menu && slug(menu.fields.title.toLowerCase()) === menuSubSlug) {
                          return(
                            <div className={'submenu cols-'+menu.fields.columns} key={menu.fields.title} id={slug(menu.fields.title.toLowerCase())}>
                              {menuSubSlug && <h1>{menu.fields.longTitle ? menu.fields.longTitle : menu.fields.title}</h1>}
                              {menuSubSlug && <ReactMarkdown source={menu.fields.description} softBreak="br" />}
                              {menu.fields.children && menu.fields.children.map((child) => {
                                let product = products.find((p) => {
                                  return p.sys.id === child.sys.id
                                })
                                let category = categories.find((p) => {
                                  return p.sys.id === child.sys.id
                                })
                                if(product) {
                                  return(
                                    <RenderProduct product={product} key={product.fields.title} {...this.props} />
                                  )
                                }

                                if(category) {
                                  return(
                                    <RenderCategory category={category} key={category.fields.title} {...this.props} />
                                  )
                                }

                                return null;
                              })}
                            </div>
                          )
                        }
                        return null;
                      })}
                    </div>
                  </div>
              </div>
            }
            </div>
          )})
        }
      </div>
    );
  }
}

MenuPage.propTypes = {
  intl: intlShape.isRequired,
}

const mapStateToProps = state => ({
  menus:state.menus,
  date:state.date,
  products:state.products,
  categories:state.categories
});

const mapDispatchToProps = {
  fetchMenu
};

export default connect(mapStateToProps,mapDispatchToProps)(injectIntl(MenuPage));



// WEBPACK FOOTER //
// ./src/containers/MenuPage.js